import { Calculate } from '@mui/icons-material';
import { Stack, Tooltip } from '@mui/material';
import {
  CollapsibleTable,
  GenDate,
  GenCurrency,
} from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';
import Empty from '../../../assets/emptyUnapproved.png';
import { OrderTypes } from '../../../common/enums/enums';
import { filterOrdersForApproval } from '../../../helpers/orders';
import EmptyState from '../../orders/components/EmptyState';
import { getServicesPendingToApprove } from '../hooks/useStatusByOrder';
import useVehicleOrdersForApproval from '../hooks/useVehicleOrdersForApproval';
import ListOfDetails from './ListOfDetails';

export default function Table() {
  const { t } = useTranslation('approvals');
  const { isLoading, hasNextPage, isEmpty, vehicleOrders, loadMore } =
    useVehicleOrdersForApproval();
  const columns = [
    {
      field: 'dateOrdered',
      headerName: t('dateOrdered'),
      valueGetter: order => <GenDate date={order.dateOrdered} noTime={true} />,
    },
    {
      field: 'stockNumber',
      headerName: t('stockNumber'),
    },
    {
      field: 'vin',
      headerName: t('vin'),
    },
    {
      field: 'vendor',
      headerName: t('vendor'),
      valueGetter: order =>
        order.relatedOrders.find(
          relatedOrder => relatedOrder.orderType !== OrderTypes.RECONDITIONING
        )?.vendorName,
    },
    {
      field: 'services',
      headerName: t('services'),
      valueGetter: order => getServicesPendingToApprove(order)?.length,
    },
    {
      field: 'price',
      headerName: t('price'),
      valueGetter: order => (
        <GenCurrency
          value={getServicesPendingToApprove(order).reduce(
            (acc, service) => acc + service.amount,
            0
          )}
        />
      ),
    },
    {
      field: 'isReconditioning',
      valueGetter: order =>
        (order.orderType === OrderTypes.RECONDITIONING && (
          <Stack>
            <Tooltip title={t('estimateOrder')} arrow>
              <Calculate color="info" />
            </Tooltip>
          </Stack>
        )) ||
        null,
    },
  ];

  return (
    <>
      <CollapsibleTable
        columns={columns}
        rows={filterOrdersForApproval(vehicleOrders)}
        hasNextPage={hasNextPage}
        loading={isLoading}
        onLoadMore={loadMore}
        onClick={() => {}}
        collpasibleGetter={info => <ListOfDetails order={info} />}
      />
      <EmptyState
        show={isEmpty}
        img={Empty}
        title={t('global:noWOUnapproveTitle')}
        subtitle={t('global:noWOApprovals')}
      />
    </>
  );
}
